import { createReducer, on } from "@ngrx/store";
import { updateState } from "@obg/ngx.global";

import { GeoFencingAction } from "./geofencing.action";
import { GEOFENCING_ERROR } from "./geofencing.const";
import { CountryAreaStatus, GeoFencingState } from "./geofencing.model";

const INITIAL_STATE: GeoFencingState = {
	valid: undefined,
	error: undefined,
	showNotification: false,
	isBusy: false,
	countryAreaStatus: CountryAreaStatus.Unset,
	isWageringBlockDialogEnabled: false,
	locationId: undefined,
};

export const geoFencingReducer = createReducer(
	INITIAL_STATE,
	on(GeoFencingAction.validateLocation, (state) =>
		updateState(state, {
			showNotification: true,
			isBusy: true,
			valid: undefined,
			error: undefined,
		})
	),
	on(GeoFencingAction.validateBrazilLocation, (state) =>
		updateState(state, {
			showNotification: true,
			isBusy: true,
			valid: undefined,
			error: undefined,
		})
	),
	on(GeoFencingAction.validateArgentineLocationSuccess, (state, { valid, locationId, error }) =>
		updateState(state, {
			valid,
			isBusy: false,
			error,
			locationId,
		})
	),
	on(GeoFencingAction.validateLocationSuccess, (state, { valid, error }) =>
		updateState(state, {
			valid,
			isBusy: false,
			error: error ? error : valid ? undefined : GEOFENCING_ERROR.InvalidPosition,
		})
	),
	on(GeoFencingAction.validateLocationFailure, (state, { error }) =>
		updateState(state, {
			valid: false,
			isBusy: false,
			showNotification: false,
			error,
			countryAreaStatus: CountryAreaStatus.Unset,
		})
	),
	on(GeoFencingAction.validateIpLocationSuccess, (state, { valid }) =>
		updateState(state, {
			countryAreaStatus: valid ? CountryAreaStatus.Restricted : CountryAreaStatus.Valid,
			isBusy: false,
			error: valid ? undefined : GEOFENCING_ERROR.InvalidPosition,
		})
	),
	on(GeoFencingAction.validateIpLocationFailure, (state, { error }) =>
		updateState(state, {
			valid: false,
			isBusy: false,
			showNotification: false,
			error,
			countryAreaStatus: CountryAreaStatus.Unset,
		})
	),
	on(GeoFencingAction.getArgentinaLocationSuccess, (state) =>
		updateState(state, {
			showNotification: false,
		})
	),
	on(GeoFencingAction.getBrazilLocationSuccess, (state) =>
		updateState(state, {
			showNotification: false,
		})
	),
	on(GeoFencingAction.getAwsLocationSuccess, (state) =>
		updateState(state, {
			showNotification: false,
		})
	),
	on(GeoFencingAction.setWageringBlockDialogEnabled, (state, { wageringBlockDialogEnabled }) =>
		updateState(state, {
			isWageringBlockDialogEnabled: wageringBlockDialogEnabled,
		})
	),
	on(GeoFencingAction.resetError, (state) =>
		updateState(state, {
			valid: undefined,
			error: undefined,
		})
	)
);
